import PlaceAutoComplete from './PlaceAutoComplete';

export default PlaceAutoComplete;
